import React, { useState } from 'react';
import "../CssDesing/DailyTargetLineDetail.css"
import { Carousel } from "react-bootstrap";
import { useParams } from "react-router-dom"
import { IntlProvider, FormattedMessage } from "react-intl";
import HourlyProductionTable from '../components/HourlyProductionTable';
import BreakScreen from '../components/BreakScreen';

const DailyTargetLineDetail = (props) => {
    const RerfeshDataTimer = 120000;
    // Mola listesi ve sunucu saati bu aralıkta yeniden alınır; aradaki saniyeleri
    // istemci kendisi sayar, böylece mola tam saniyesinde açılıp kapanır.
    const BreakSyncTimer = 300000;

    const hourlyProductionTracking = process.env.REACT_APP_HOURLY_PRODUCTION_TRACKING_URL;
    const breakScreen = process.env.REACT_APP_BREAK_SCREEN_URL;
    const dailyTargetLineDetail = "https://api.itmtechsoft.com/api/Lcd/DailyTargetEfficiencyOfTheLine"

    const [error, setError] = useState(null);

    const [dailyTarget, setdailtTarget] = React.useState();
    const [sequance, setSequance] = React.useState();
    const [production, setProduction] = React.useState();
    const [restQuality, setrestQuality] = React.useState();
    const [productivity, setProductivity] = React.useState();
    const [operatorCount, setoperatorCount] = React.useState();
    const [trackingData, setTrackingData] = React.useState(null);
    const [lineName, setlineName] = React.useState();

    const [breakInfo, setBreakInfo] = React.useState(null);
    const [activeBreak, setActiveBreak] = React.useState(null);
    const [remainingSeconds, setRemainingSeconds] = React.useState(0);


    let { screenId } = useParams();
    let { companyName } = useParams();


    const localization = {
        'tr': {
            productionTitle: "SIRALAMA",
            dailyproductivityTitle: "GÜNLÜK",
            activeperTitle: "AKTİF ÇAL:",
            dailytargetTitle: "GÜNLÜK",
            kalan: "KALAN",
            targetName: "HEDEF",
            productionName: "ÜRETİM"
        },
        'tr-TR': {
            productionTitle: "SIRALAMA",
            dailyproductivityTitle: "GÜNLÜK",
            activeperTitle: "AKTİF ÇAL:",
            dailytargetTitle: "GÜNLÜK",
            kalan: "KALAN",
            targetName: "HEDEF",
            productionName: "ÜRETİM"
        },
        'en-US': {
            productionTitle: "ARRANGEMENT",
            dailyproductivityTitle: "DAILY",
            activeperTitle: "ACTIVE PER:",
            dailytargetTitle: "DAILY",
            kalan: "REMAINDER",
            targetName: "TARGET",
            productionName: "PRODUCTION"
        },
        'en': {
            productionTitle: "ARRANGEMENT",
            dailyproductivityTitle: "DAILY",
            activeperTitle: "ACTIVE PER:",
            dailytargetTitle: "DAILY",
            kalan: "REMAINDER",
            targetName: "TARGET",
            productionName: "PRODUCTION"
        },
        'ar': {
            productionTitle: "إنتاج",
            dailyproductivityTitle: "إنتاجية",
            activeperTitle: ":الموظفون الن"
        }
    }

    const defaultLocale = navigator.language;

    // Fallback mekanizması ekleyin
    const supportedLocales = ['tr', 'tr-TR', 'en-US', 'ar', 'en'];
    const fallbackLocale = 'en-US';
    const language = supportedLocales.includes(defaultLocale) ? defaultLocale : fallbackLocale;

    React.useEffect(() => {
        const fetchLCDData = () => {
            var url = ``;
            if (companyName == null) {
                url = `${dailyTargetLineDetail}?lcdNo=${screenId}`;
            }
            else {
                url = `${dailyTargetLineDetail}?lcdNo=${screenId}&companyName=${companyName}`;
            }
            fetch(url)
                .then((response) => response.json())
                .then((respData) => {
                    const respSequance = respData?.sequent || "";
                    const respDailyTarget = respData?.target || "";
                    const respproductivity = respData?.productivity || [];
                    const respproduction = respData?.production || [];
                    const respRestQuality = respDailyTarget - respproduction
                    const respemployeeCount = respData?.operatorCount
                    const respLineName = respData?.lineName

                    setSequance(respSequance);
                    setdailtTarget(respDailyTarget);
                    setProductivity(respproductivity);
                    setProduction(respproduction);
                    setrestQuality(respRestQuality);
                    setoperatorCount(respemployeeCount);
                    setlineName(respLineName)
                    
                })

        }

        fetchLCDData();

        const interval = setInterval(fetchLCDData, RerfeshDataTimer);
        return () => {
            clearInterval(interval);
        };

    }, [ screenId, companyName])

    const getProductivityStyle = (productivity) => {
        if (productivity < 100) return { background: 'red' };
        if (productivity === 100) return { background: 'blue' };
        if (productivity > 100) return { background: 'green' };
        return {};
    }

    React.useEffect(() => {

        const fetchHourlyProductionTracking = () => {
            var url = ``;
            if (companyName == null) {
                url = `${hourlyProductionTracking}?lcdNo=${screenId}`;
            }
            else {
                url = `${hourlyProductionTracking}?lcdNo=${screenId}&companyName=${companyName}`;
            }
            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((respData) => {

                    setTrackingData(respData);

                    setError(null);  // Clear error if data is fetched successfully
                })
                .catch((error) => {
                    console.error('Fetching error:', error);
                    setError('LCD NUMARASI YANLIŞ. LÜTFEN KONTROL EDİNİZ.');  // Set error message
                });
        };
        fetchHourlyProductionTracking();

        const interval = setInterval(fetchHourlyProductionTracking, RerfeshDataTimer);
        return () => {
            clearInterval(interval);
        };
    }, [screenId, companyName])

    // "HH:mm:ss" -> gün başından itibaren saniye
    const toDaySeconds = (value) => {
        const parts = String(value || '').split(':');
        return (Number(parts[0]) || 0) * 3600 + (Number(parts[1]) || 0) * 60 + (Number(parts[2]) || 0);
    };

    // Molalar ve fabrikanın yerel saati. Cihaz saati ile fabrika saati arasındaki fark
    // bir kez ölçülür; mola kontrolü hep bu farkla düzeltilmiş saat üzerinden yapılır,
    // böylece LCD cihazının saati kaymış olsa bile mola doğru anda açılır.
    React.useEffect(() => {
        const fetchBreakScreen = () => {
            var url = ``;
            if (companyName == null) {
                url = `${breakScreen}?lcdNo=${screenId}`;
            }
            else {
                url = `${breakScreen}?lcdNo=${screenId}&companyName=${companyName}`;
            }
            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((respData) => {
                    const device = new Date();
                    const deviceSeconds = device.getHours() * 3600 + device.getMinutes() * 60 + device.getSeconds();

                    setBreakInfo({
                        offsetSeconds: toDaySeconds(respData?.serverTime) - deviceSeconds,
                        breaks: (respData?.breaks || []).map((b) => ({
                            name: b.name,
                            startSeconds: toDaySeconds(b.startTime),
                            endSeconds: toDaySeconds(b.endTime)
                        }))
                    });
                })
                .catch((error) => {
                    console.error('Break fetching error:', error);
                });
        };
        fetchBreakScreen();

        const interval = setInterval(fetchBreakScreen, BreakSyncTimer);
        return () => {
            clearInterval(interval);
        };
    }, [screenId, companyName])

    // Saniyede bir: şu an mola var mı, varsa ne kadar kaldı
    React.useEffect(() => {
        if (breakInfo == null) {
            return;
        }

        const evaluateBreak = () => {
            const device = new Date();
            const deviceSeconds = device.getHours() * 3600 + device.getMinutes() * 60 + device.getSeconds();
            const nowSeconds = (((deviceSeconds + breakInfo.offsetSeconds) % 86400) + 86400) % 86400;

            let current = null;
            let remaining = 0;

            for (const item of breakInfo.breaks) {
                // Gece vardiyasında mola gece yarısını aşabilir (bitiş < başlangıç)
                const crossesMidnight = item.endSeconds <= item.startSeconds;
                const isActive = crossesMidnight
                    ? (nowSeconds >= item.startSeconds || nowSeconds < item.endSeconds)
                    : (nowSeconds >= item.startSeconds && nowSeconds < item.endSeconds);

                if (isActive) {
                    const total = crossesMidnight
                        ? 86400 - item.startSeconds + item.endSeconds
                        : item.endSeconds - item.startSeconds;

                    remaining = nowSeconds < item.endSeconds
                        ? item.endSeconds - nowSeconds
                        : 86400 - nowSeconds + item.endSeconds;

                    current = { ...item, totalSeconds: total };
                    break;
                }
            }

            setActiveBreak(current);
            setRemainingSeconds(remaining);
        };

        evaluateBreak();

        const interval = setInterval(evaluateBreak, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [breakInfo])

    // Mola süresince carousel durur, ekranı yalnızca mola sayfası kaplar
    if (activeBreak != null) {
        return <BreakScreen activeBreak={activeBreak} remainingSeconds={remainingSeconds} />;
    }

    return (
        <Carousel
            indicators={false}
            controls={false}
            interval={60000}  //60000
            pause={false}>
            <Carousel.Item key={1}>
                <div className="windowSize">
                    <div className="kart-container">
                        <div className="title1">
                            <IntlProvider locale={language} messages={localization[language]}>
                                <FormattedMessage id='targetName' />
                            </IntlProvider>
                        </div>
                        <div className="title2">{sequance}</div>
                        <div className="title3">
                            <IntlProvider locale={language} messages={localization[language]}>
                                <FormattedMessage id='productionName' />
                            </IntlProvider>
                        </div>
                    </div>
                    <div className="kart-container">
                        <div className="title4">
                            <IntlProvider locale={language} messages={localization[language]}>
                                <FormattedMessage id='dailytargetTitle' />
                            </IntlProvider>
                        </div>
                        <div className="title4">
                            <IntlProvider locale={language} messages={localization[language]}>
                                <FormattedMessage id='productionTitle' />
                            </IntlProvider>
                        </div>
                        <div className="title4">
                            <IntlProvider locale={language} messages={localization[language]}>
                                <FormattedMessage id='dailyproductivityTitle' />
                            </IntlProvider>
                        </div>
                    </div>
                    <div className="kart-container">
                        <div className="title5">
                            <div className="half">
                                <div className="box">{dailyTarget}</div>
                            </div>
                            <div className="half">
                                <span>
                                    <IntlProvider locale={language} messages={localization[language]}>
                                        <FormattedMessage id='activeperTitle' />
                                    </IntlProvider>
                                </span>
                                <div className="box">{operatorCount}</div>
                            </div>
                        </div>
                        <div className="title6">
                            <div className="circle" style={getProductivityStyle(productivity)}>% {productivity}</div>
                        </div>
                        <div className="title7">
                            <div className="half">
                                <div className="box2">{production}</div>
                            </div>
                            <div className="half">
                                <span>
                                    <IntlProvider locale={language} messages={localization[language]}>
                                        <FormattedMessage id='kalan' />
                                    </IntlProvider>
                                </span>
                                <div className="box2">{restQuality}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Carousel.Item>
            <Carousel.Item key={2}>
                <div className="windowSize" >

                    <HourlyProductionTable trackingData={trackingData} lineName={lineName} />

                </div>
            </Carousel.Item>
        </Carousel>
    );
}

export default DailyTargetLineDetail;